
import React, { useState, useEffect } from 'react';
import { Spinner } from "reactstrap";
import { useParams } from 'react-router-dom';

import UserLevels from './UserLevels';
import { getUserById } from '../../helpers/satiBack';

const Levels = () => {
  let { id } = useParams();
  const [user, setUser] = useState({});
  const [isLoading, setLoading] = useState(true)

  useEffect(() => {
    getUserById(id)
      .then(data => {
        setUser(data);
        setLoading(false);
      })
      .catch(err => console.error(err))     // TODO: Error handling
  }, [id]);

  


  if(isLoading){
    return (
    <div className="App">
      Loading...
      <Spinner size="l" color="dark" className="mr-2"/>
    </div>
    );
  }
  
  return <UserLevels user={user}/>


}

export default Levels;
